/* Extend the theme's existing events; never change order properties or consent. */
(() => {
  class MoonreedDeliveryProgress extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      document.addEventListener('cart:change', event => this.update(event.detail?.cart), {signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    update(cart) {
      if (!cart) return;
      const threshold = Number(this.dataset.threshold);
      this.hidden = !(threshold > 0) || cart.currency !== 'GBP' || cart.requires_shipping === false || cart.item_count === 0;
      if (this.hidden) return;
      const total = Math.max(0, Number(cart.total_price) || 0);
      const remaining = Math.max(0, threshold - total);
      const percent = Math.min(100, Math.round(total / threshold * 100));
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:'GBP'}).format(remaining / 100);
      this.querySelector('p').textContent = remaining ? this.dataset.unreached.replace('[amount]', amount) : this.dataset.reached;
      const track = this.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuenow', String(percent));
      track.firstElementChild.style.width = `${percent}%`;
    }
  }
  class MoonreedGalleryControls extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.carousel = document.getElementById(this.getAttribute('carousel-id'));
      if (!this.carousel) return;
      ['carousel:change','carousel:settle','carousel:filter'].forEach(name => this.carousel.addEventListener(name, () => this.update(), {signal:this.abort.signal}));
      this.update();
      customElements.whenDefined('scroll-carousel').then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() { this.abort?.abort(); }
    update() {
      const cells = Array.from(this.carousel.children).filter(cell => !cell.hidden);
      const selected = this.carousel.selectedCell || this.carousel.querySelector('.is-initial');
      const current = Math.max(0, cells.indexOf(selected)) + 1;
      const count = this.querySelector('[data-gallery-count]');
      count.textContent = `${cells.length ? current : 0} / ${cells.length}`;
      count.setAttribute('aria-label', this.dataset.countLabel.replace('[current]', String(cells.length ? current : 0)).replace('[total]', String(cells.length)));
      this.querySelectorAll('carousel-prev-button,carousel-next-button').forEach(control => { control.hidden = cells.length < 2; });
    }
  }
  if (!customElements.get('mr-delivery-progress')) customElements.define('mr-delivery-progress', MoonreedDeliveryProgress);
  if (!customElements.get('mr-gallery-controls')) customElements.define('mr-gallery-controls', MoonreedGalleryControls);
  function connectPrivacyPreferences() {
    if (typeof window.Shopify?.privacyBanner?.showPreferences !== 'function') return false;
    document.querySelectorAll('[data-mr-cookie-preferences]').forEach(button => {
      button.hidden = false;
      if (button.dataset.connected) return;
      button.dataset.connected = 'true';
      button.addEventListener('click', () => window.Shopify.privacyBanner.showPreferences());
    });
    return true;
  }
  if (!connectPrivacyPreferences()) {
    let attempts = 0;
    const timer = setInterval(() => { if (connectPrivacyPreferences() || ++attempts >= 40) clearInterval(timer); }, 500);
  }
  window.addEventListener('load', connectPrivacyPreferences, {once:true});
  document.addEventListener('shopify:section:load', connectPrivacyPreferences);
})();
